import { DatesRange } from '@radioking/planning';
import { BreakDetails } from '../models/break.model';

const tag = '[Break]';

export class GetBreakListRequest {
  static readonly type = `${tag} request get break list`;
  constructor(public range: DatesRange) {}
}

export class GetBreakListSuccess {
  static readonly type = `${tag} success get break list`;
}

export class GetBreakListFailure {
  static readonly type = `${tag} error get break list`;
  constructor(public error: Error) {}
}

export class GetBreakRequest {
  static readonly type = `${tag} request get break`;
  constructor(public breakId: number) {}
}

export class GetBreakSuccess {
  static readonly type = `${tag} success get break`;
}

export class GetBreakFailure {
  static readonly type = `${tag} error get break`;
  constructor(public error: Error) {}
}

export class CreateBreakRequest {
  static readonly type = `${tag} request create break`;
  constructor(public breakObj: BreakDetails) {}
}

export class CreateBreakSuccess {
  static readonly type = `${tag} success create break`;
  constructor(public breakObj: BreakDetails) {}
}

export class CreateBreakFailure {
  static readonly type = `${tag} error create break`;
  constructor(public error: Error) {}
}

export class EditBreakRequest {
  static readonly type = `${tag} request edit break`;
  constructor(public breakObj: BreakDetails) {}
}

export class EditBreakSuccess {
  static readonly type = `${tag} success edit break`;
}

export class EditBreakFailure {
  static readonly type = `${tag} error edit break`;
  constructor(public error: Error) {}
}

export class DeleteBreakRequest {
  static readonly type = `${tag} request delete break`;
  constructor(
    public deleteAll: boolean,
    public breakId: number,
    public occurrenceId: number,
  ) {}
}

export class DeleteBreakSuccess {
  static readonly type = `${tag} success delete break`;
}

export class DeleteSelectedBreaksFailure {
  static readonly type = `${tag} error delete selected breaks`;
  constructor(public error: Error) {}
}

export class DeleteSelectedBreaksRequest {
  static readonly type = `${tag} request delete selected breaks`;
}

export class DeleteSelectedBreaksSuccess {
  static readonly type = `${tag} success delete selected breaks`;
}

export class DeleteBreakFailure {
  static readonly type = `${tag} error delete break`;
  constructor(public error: Error) {}
}

export class SelectBreaks {
  static readonly type = `${tag} select breaks`;
  constructor(public selectedBreaks: number[]) {}
}

export class ResetBreak {
  static readonly type = `${tag} reset break`;
}

export class BreaksRendered {
  static readonly type = `${tag} breaks rendered`;
}

export class ResetBreakState {
  static readonly type = `${tag} reset break state`;
}

export class SetCurrentDay {
  static readonly type = `${tag} set current day`;
  constructor(public currentDay: moment.Moment) {}
}

// Action to trigger a toast if no content is selected in the form 1st step
export class NoContentSelected {
  static readonly type = `${tag} no content selected`;
}

export class TooltipNoContent {
  static readonly type = `${tag} tooltip no content`;
}
